import { render, staticRenderFns } from "./set-top-article.vue?vue&type=template&id=f482b44c&scoped=true&"
import script from "./set-top-article.vue?vue&type=script&lang=ts&"
export * from "./set-top-article.vue?vue&type=script&lang=ts&"
import style0 from "./set-top-article.vue?vue&type=style&index=0&id=f482b44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f482b44c",
  null
  
)

export default component.exports